import React, {memo} from "react";
import TransactionType from "../../../../TransactionType";

function Type(props) {
    const { record } = props;

    return (
        <div className="BaseTable__row-cell-text">
            <TransactionType record={record} />
        </div>
    );
}

export default memo(Type);
